import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { post } from 'helpers/api';
import { fetchTranslation } from '../../../../helpers/i18n';

// Shown while a new login waits on its email to be confirmed before it takes over the visitor's saved profile
export default function ConfirmEmailToFinish({ email, resendVerificationPath }) {
  const [emailResent, setEmailResent] = useState(false);

  const resendEmail = async () => {
    await post(resendVerificationPath, { email });
    setEmailResent(true);
    setTimeout(() => setEmailResent(false), 5000);
  };

  return (
    <div className="text-center">
      <div className="mb-6 mt-2 text-branding">
        <FontAwesomeIcon icon={faEnvelope} size="2x"/>
      </div>
      <h5 className="mb-4"><strong>{fetchTranslation('check_your_email')}</strong></h5>
      <p>{fetchTranslation('confirm_email_to_finish_account', { email })}</p>
      <Button disabled={emailResent} name="resend-confirmation" variant="ghost" onClick={resendEmail}>
        {fetchTranslation('resend_verification_email')}
      </Button>
      {emailResent && (
        <div className="animate__animated animate__fadeInUp text-branding mt-3">
          {fetchTranslation('email_verification_resent')}
        </div>
      )}
    </div>
  );
}

ConfirmEmailToFinish.propTypes = {
  email: PropTypes.string.isRequired,
  resendVerificationPath: PropTypes.string.isRequired
};
